/* unplugin-vue-components disabled */import { render } from "./moduleTitle.vue?vue&type=template&id=383caf6c&scoped=true"
import script from "./moduleTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./moduleTitle.vue?vue&type=script&setup=true&lang=js"

import "./moduleTitle.vue?vue&type=style&index=0&id=383caf6c&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./moduleTitle.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_56c7d0d1d885c2cba1c2415451171383/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383caf6c"],['__file',"src/components/moduleTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "383caf6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('383caf6c', __exports__)) {
    api.reload('383caf6c', __exports__)
  }
  
  module.hot.accept("./moduleTitle.vue?vue&type=template&id=383caf6c&scoped=true", () => {
    api.rerender('383caf6c', render)
  })

}


export default __exports__